export const getShadowRoot = (el) => {
    const rootNode = el?.getRootNode();
    return rootNode instanceof ShadowRoot ? rootNode : null;
};
